import { Routes } from '@angular/router';
import { LayoutMainComponent } from './components/layout/layout.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { AgpmCurrentNoticeComponent } from './pages/agpm/current-notice/current-notice.component';
import { PaaEditPlanComponent } from './pages/paa/edit-plan/edit-plan.component';
import { PaaHistoryComponent } from './pages/paa/history/history.component';
import { PpmCurrentPlansComponent } from './pages/ppm/current-plans/current-plans.component';
import { PpmHistoryComponent } from './pages/ppm/history/history.component';
import { AgpmNewNoticeComponent } from './pages/agpm/new-notice/new-notice.component';
import { PaaNewPlanComponent } from './pages/paa/new-plan/new-plan.component';
import { ForbiddenComponent } from './components/shared/forbidden/forbidden.component';
import { ContractingAuthorityComponent } from './pages/settings/contracting-authority/contracting-authority.component';
import { RefParamsComponent } from './pages/settings/ref-params/ref-params.component';
import { RefTypeComponent } from './pages/settings/ref-type/ref-type.component';
import { CompanyComponent } from './pages/settings/company/company.component';
import { CommitteeComponent } from './pages/settings/committee/committee.component';
import { PpmNewPlanComponent } from './pages/ppm/new-plan/new-plan.component';
import { AddCompanyComponent } from './pages/settings/company/add-company/add-company.component';
import { AgpmEditNoticeComponent } from './pages/agpm/edit-notice/edit-notice.component';
import { UpdateCompanyComponent } from './pages/settings/company/update-company/update-company.component';
import { CurrentTasksComponent } from './pages/current-tasks/current-tasks.component';
import { PaaTaskDetailsComponent } from './pages/paa/task-details/task-details.component';
import { DocumentDynamicsComponent } from './pages/settings/document-dynamics/document-dynamics.component';
import { ManageDocumentDynamicsComponent } from './pages/settings/document-dynamics/manage-document-dynamics/manage-document-dynamics.component';
import { PpmEditPlanComponent } from './pages/ppm/edit-plan/edit-plan.component';
import { PpmTaskDetailsComponent } from './pages/ppm/task-details/task-details.component';
import { AddCommitteeComponent } from './pages/settings/committee/add-committee/add-committee.component';
import { EditCommitteeComponent } from './pages/settings/committee/edit-committee/edit-committee.component';
import { UserComponent } from './pages/settings/user/user.component';
import { AddUserComponent } from './pages/settings/user/add-user/add-user.component';
import { UpdateUserComponent } from './pages/settings/user/update-user/update-user.component';
import { ContractingAuthorityDetailsComponent } from './pages/settings/contracting-authority/contracting-authority-details/contracting-authority-details.component';
import { AddContractingAuthorityComponent } from './pages/settings/contracting-authority/add-contracting-authority/add-contracting-authority.component';
import { UpdateContractingAuthorityComponent } from './pages/settings/contracting-authority/update-contracting-authority/update-contracting-authority.component';
import { DacComponent } from './pages/dac/dac.component';
import { EditDacComponent } from './pages/dac/edit-dac/edit-dac.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { AgpmTaskDetailsComponent } from './pages/agpm/task-details/task-details.component';
import { PpmInspectPlanComponent } from './pages/ppm/inspect-plan/inspect-plan.component';
import { PaaInspectPlanComponent } from './pages/paa/inspect-plan/inspect-plan.component';
import { PaaCurrentPlansComponent } from './pages/paa/current-plans/current-plans.component';
import { PaaVersionHistoryComponent } from './pages/paa/version-history/version-history.component';
import { AgpmHistoryComponent } from './pages/agpm/history/history.component';
import { PpmHistoryPVComponent } from './pages/ppm/history-pv/history-pv.component';
import { roleBasedGuard } from './guards/role-based.guard';
import { UserRole } from './types/user.types';
import { PpmVersionHistoryComponent } from './pages/ppm/version-history/version-history.component';
import { PaaTaskHistoryComponent } from './pages/paa/task-history/task-history.component';
import { PpmTaskHistoryComponent } from './pages/ppm/task-history/task-history.component';
import { AgpmTaskHistoryComponent } from './pages/agpm/task-history/task-history.component';
import { AgpmVersionHistoryComponent } from './pages/agpm/version-history/version-history.component';
import { CurrencyComponent } from './pages/settings/currency/currency.component';
import { PassingModeComponent } from './pages/settings/passing-mode/passing-mode.component';
import { EmailTraceComponent } from './pages/settings/email-trace/email-trace.component';
import { DelaisReglementairesComponent } from './pages/settings/delais-reglementaires/delais-reglementaires.component';
import { MeetingsListComponent } from './pages/meeting/meetings-list/meetings-list.component';
import { NewMeetingComponent } from './pages/meeting/new-meeting/new-meeting.component';
import { EditMeetingComponent } from './pages/meeting/edit-meeting/edit-meeting.component';
import { InspectMeetingComponent } from './pages/meeting/inspect-meeting/inspect-meeting.component';
import { MeetingConveneComponent } from './pages/meeting/meeting-convene/meeting-convene.component';
import { InspectConvenedMeetingComponent } from './pages/meeting/inspect-convened-meeting/inspect-convened-meeting.component';
import { AgpmInspectNoticeComponent } from './pages/agpm/inspect-notice/inspect-notice.component';
import { InspectDacComponent } from './pages/dac/inspect-dac/inspect-dac.component';
import { ActivityComponent } from './pages/settings/activity/activity.component';
import { DocSubmissionComponent } from './pages/settings/doc-submission/doc-submission.component';
import { ApprovalTypeComponent } from './pages/settings/approval-type/approval-type.component';
import { DynamicFormsComponent } from './pages/settings/dynamic-forms/dynamic-forms.component';
import { NewDynamicFormComponent } from './pages/settings/dynamic-forms/new-dynamic-form/new-dynamic-form.component';
import { EditDynamicFormComponent } from './pages/settings/dynamic-forms/edit-dynamic-form/edit-dynamic-form.component';
import { InspectDynamicFormComponent } from './pages/settings/dynamic-forms/inspect-dynamic-form/inspect-dynamic-form.component';
import { DynaDocsModelsComponent } from './pages/settings/dyna-docs-models/dyna-docs-models.component';
import { SeuilsGlobalComponent } from './pages/settings/seuils-global/seuils-global.component';
import { InspectCompanyComponent } from './pages/settings/company/inspect-company/inspect-company.component';
import { CompanyRequestComponent } from './pages/settings/company-request/company-request.component';
import { TreatCompanyRequestComponent } from './pages/settings/company-request/treat-company-request/treat-company-request.component';
import { AcHistoryComponent } from './pages/settings/contracting-authority/ac-history/ac-history.component';
import { CurrencyHistoryComponent } from './pages/settings/currency/currency-history/currency-history.component';
import { CommitteeHistoryComponent } from '@/pages/settings/committee/committee-history/committee-history.component';
import { ConselliersHistoryComponent } from '@/pages/settings/committee/conselliers-history/conselliers-history.component';
import { MeetingsHistoryComponent } from './pages/meeting/meetings-history/meetings-history.component';
import { ClarificationCurrentQuestionsComponent } from './pages/clarification-request/current-questions/current-questions.component';
import { DacTaskHistoryComponent } from './pages/dac/task-history/task-history.component';
import { HistoryDetailsComponent } from './pages/meeting/meetings-history/history-details/history-details.component';
import { CallForTenderComponent } from './pages/ao/ao.component';
import { NewTenderComponent } from './pages/ao/new-tender/new-tender.component';
import { InspectTenderComponent } from './pages/ao/inspect-tender/inspect-tender.component';
import { EditTenderComponent } from './pages/ao/edit-tender/edit-tender.component';
import { CompanySubmissionsBlacklistComponent } from './pages/settings/company-request/company-submissions-blacklist/company-submissions-blacklist.component';
import { PaymentJustificationComponent } from './pages/settings/payment-justification/payment-justification.component';
import { FundingSourcesComponent } from './pages/settings/funding-sources/funding-sources.component';
import { DacGeneralParamsComponent } from './pages/settings/dac-general-params/dac-general-params.component';
import { NewDacGeneralParamsComponent } from './pages/settings/dac-general-params/new-dac-general-params/new-dac-general-params.component';
import { EditDacGeneralParamsComponent } from './pages/settings/dac-general-params/edit-dac-general-params/edit-dac-general-params.component';
import { DacScenariosComponent } from './pages/settings/dac-scenarios/dac-scenarios.component';
import { AddDacScenariosComponent } from './pages/settings/dac-scenarios/add-dac-scenarios/add-dac-scenarios.component';
import { EditDacScenariosComponent } from './pages/settings/dac-scenarios/edit-dac-scenarios/edit-dac-scenarios.component';
import { InspectDacScenariosComponent } from './pages/settings/dac-scenarios/inspect-dac-scenarios/inspect-dac-scenarios.component';
import { boClientGuard } from '@/bo-client.guard';
import { ReportRequestComponent } from './pages/report-request/report-request.component';
import { ReportsComponent } from './pages/reports/reports.component';
import { CreateReportsComponent } from './pages/reports/create-reports/create-reports.component';
import { DacConfigurationComponent } from './pages/dac/dac-configuration/dac-configuration.component';
import { DacTaskDetailsComponent } from './pages/dac/task-details/task-details.component';
import { ClarificationRedacteurDacGroupComponent } from './pages/clarification-request/redacteur-dac-group/redacteur-dac-group.component';

export const appRoutes: Routes = [
  {
    path: '',
    component: LayoutMainComponent,
    canActivate: [boClientGuard],
    children: [
      // { path: 'form-test', component: FormTestComponent },
      // { path: 'datatable-test', component: DataTableTestComponent },

      { path: '', component: DashboardComponent },
      { path: 'current-tasks', component: CurrentTasksComponent },
      //agpm
      { path: 'agpm-current-notice', component: AgpmCurrentNoticeComponent },
      { path: 'agpm-new-notice', component: AgpmNewNoticeComponent },
      { path: 'agpm-inspect-notice/:id/:version', component: AgpmInspectNoticeComponent },
      { path: 'agpm-inspect-notice/:id', component: AgpmInspectNoticeComponent },
      { path: 'agpm-edit-notice/:id', component: AgpmEditNoticeComponent },
      { path: 'agpm-history', component: AgpmHistoryComponent },
      { path: 'agpm-version-history/:id', component: AgpmVersionHistoryComponent },
      { path: 'agpm-current-task/:taskId', component: AgpmTaskDetailsComponent },
      { path: 'agpm-task-history/:processInstanceId', component: AgpmTaskHistoryComponent },
      //paa
      { path: 'paa-current-plans', component: PaaCurrentPlansComponent },
      { path: 'paa-new-plan', component: PaaNewPlanComponent },
      { path: 'paa-inspect-plan/:id/:version', component: PaaInspectPlanComponent },
      { path: 'paa-inspect-plan/:id', component: PaaInspectPlanComponent },
      { path: 'paa-edit-plan/:id', component: PaaEditPlanComponent },
      { path: 'paa-current-task/:taskId', component: PaaTaskDetailsComponent },
      { path: 'paa-history', component: PaaHistoryComponent },
      { path: 'paa-version-history/:id', component: PaaVersionHistoryComponent },
      { path: 'paa-task-history/:processInstanceId', component: PaaTaskHistoryComponent },
      //ppm
      { path: 'ppm-current-task/:taskId', component: PpmTaskDetailsComponent },
      { path: 'ppm-current-plans', component: PpmCurrentPlansComponent },
      { path: 'ppm-new-plan', component: PpmNewPlanComponent },
      { path: 'ppm-inspect-plan/:id', component: PpmInspectPlanComponent },
      { path: 'ppm-inspect-plan/:id/:version', component: PpmInspectPlanComponent },
      { path: 'ppm-edit-plan/:id', component: PpmEditPlanComponent },
      { path: 'ppm-history', component: PpmHistoryComponent },
      { path: 'ppm-history-pv', component: PpmHistoryPVComponent },
      { path: 'ppm-version-history/:id', component: PpmVersionHistoryComponent },
      { path: 'ppm-task-history/:processInstanceId', component: PpmTaskHistoryComponent },
      //ao
      { path: 'call-for-tender', component: CallForTenderComponent },
      { path: 'new-tender', component: NewTenderComponent,
        canActivate: [
          roleBasedGuard([
            UserRole.SUPER_ADMIN,
            UserRole.ADMIN_CENTRAL,
            UserRole.REDACTEUR_AC
            ]),
        ],
      },
      { path: 'inspect-call-for-tender/:id', component: InspectTenderComponent },
      { path: 'edit-call-for-tender/:id', component: EditTenderComponent },
      //dac
      {
        path: 'dac-create/:id/:version',
        component: EditDacComponent,
        canActivate: [
          roleBasedGuard([
            UserRole.REDACTEUR_AC,
            UserRole.VALIDATEUR_AC,
            UserRole.CPMP_RAPPORTEUR,
            UserRole.CNCMP_FILTRATION,
            UserRole.CPMP_FILTRATION,
            UserRole.CNCMP_PER_AFFECTATION,
            UserRole.CNCMP_SPE_AFFECTATION,
          ]),
        ],
      },
      { path: 'dac-configure/:id/:version', component: DacConfigurationComponent },
      { path: 'dac-inspect/:id/:version', component: InspectDacComponent },
      { path: 'dac-current-task/:taskId', component: DacTaskDetailsComponent },
      { path: 'dac-task-history/:processInstanceId', component: DacTaskHistoryComponent },
      { path: 'dac', component: DacComponent },

      //clarification
      {
        path: 'clarification',
        component: ClarificationCurrentQuestionsComponent,
        canActivate: [
          roleBasedGuard([UserRole.REDACTEUR_AC, UserRole.VALIDATEUR_AC, UserRole.CPMP_PLANIFICATEUR, UserRole.CPMP_RAPPORTEUR, UserRole.PUB_AC]),
        ],
      },
      {
        path: 'clarification-question',
        component: ClarificationRedacteurDacGroupComponent,
        canActivate: [roleBasedGuard([UserRole.REDACTEUR_AC])],
      },
      {
        path: 'outputs',
        loadComponent: () => import('./pages/clarification-request/output-list/output-list.component').then(m => m.ClarificationOutputListComponent),
      },
      {
        path: 'outputs/:demandeId',
        loadComponent: () =>
          import('./pages/clarification-request/output-details/output-details.component').then(m => m.ClarificationOutputDetailsComponent)
      },
      { path: 'report-request', component: ReportRequestComponent },
      {
        path: 'report-request/:id',
        loadComponent: () => import('./pages/report-request/report-request-details/report-request-details.component').then(m => m.ReportRequestDetailsComponent)
      },
      {
        path: 'reports',
        component: ReportsComponent,
        canActivate: [roleBasedGuard([UserRole.REDACTEUR_AC, UserRole.VALIDATEUR_AC, UserRole.CPMP_PLANIFICATEUR, UserRole.PUB_AC])],
      },
      {
        path: 'reports/create',
        component: CreateReportsComponent,
        canActivate: [roleBasedGuard([UserRole.REDACTEUR_AC, UserRole.VALIDATEUR_AC, UserRole.CPMP_PLANIFICATEUR, UserRole.PUB_AC])],
      },
      {
        path: 'reports/:dacId',
        loadComponent: () => import('./pages/reports/consult-reports/consult-reports.component').then(m => m.ConsultReportsComponent),
        canActivate: [roleBasedGuard([UserRole.REDACTEUR_AC, UserRole.VALIDATEUR_AC, UserRole.CPMP_PLANIFICATEUR, UserRole.PUB_AC])],
      },

      // meetings
      {
        path: 'meetings',
        component: MeetingsListComponent,
        canActivate: [
          roleBasedGuard([
            UserRole.SUPER_ADMIN,
            UserRole.ADMIN_CENTRAL,
            UserRole.CNCMP_PER_PLANIFICATEUR,
            UserRole.CNCMP_SPE_PLANIFICATEUR,
            UserRole.CPMP_PLANIFICATEUR,
            UserRole.CPMP_RAPPORTEUR,
            UserRole.CNCMP_PER_RAPPORTEUR,
            UserRole.CNCMP_SPE_RAPPORTEUR,
            UserRole.BACKOFFICE_USER,
          ]),
        ],
      },
      { path: 'meetings/new', component: NewMeetingComponent },
      { path: 'meetings/edit/:id', component: EditMeetingComponent },
      { path: 'meetings/inspect/:id', component: InspectMeetingComponent },
      { path: 'meetings/convene/:id', component: MeetingConveneComponent },
      { path: 'meetings/inspect-convened/:id', component: InspectConvenedMeetingComponent },
      { path: 'meetings-history', component: MeetingsHistoryComponent },
      { path: 'meetings-history/details', component: HistoryDetailsComponent },

      //rest
      { path: 'profile', component: ProfileComponent },
      { path: 'forbidden', component: ForbiddenComponent },
      { path: 'unauthorized', component: ForbiddenComponent },

      // settings
      {
        path: 'settings',
        canActivate: [roleBasedGuard([UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL, UserRole.ADMIN_AC])],
        children: [
          {
            path: 'contracting-authority',
            canActivate: [roleBasedGuard([UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL, UserRole.ADMIN_AC])],
            children: [
              { path: '', component: ContractingAuthorityComponent },
              { path: 'details/:id', component: ContractingAuthorityDetailsComponent },
              {
                path: 'add',
                canActivate: [roleBasedGuard([UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL])],
                component: AddContractingAuthorityComponent,
              },
              { path: 'update/:id', component: UpdateContractingAuthorityComponent },
              {
                path: 'ac-history',
                component: AcHistoryComponent,
                canActivate: [roleBasedGuard([UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL])],
              },
            ],
          },
          {
            path: 'ref-params',
            canActivate: [roleBasedGuard([UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL])],
            component: RefParamsComponent,
          },
          {
            path: 'currency',
            canActivate: [roleBasedGuard([UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL])],
            children: [
              { path: '', component: CurrencyComponent },
              { path: 'history', component: CurrencyHistoryComponent },
            ],
          },
          { path: 'passing-mode', canActivate: [roleBasedGuard([UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL])], component: PassingModeComponent },
          {
            path: 'dac-scenarios',
            canActivate: [roleBasedGuard([UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL])],
            children: [
              { path: '', component: DacScenariosComponent },
              { path: 'add', component: AddDacScenariosComponent },
              { path: 'edit/:id', component: EditDacScenariosComponent },
              { path: 'inspect/:id', component: InspectDacScenariosComponent },
            ],
          },
          {
            path: 'payment-justification',
            canActivate: [roleBasedGuard([UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL, UserRole.ADMIN_AC])],
            component: PaymentJustificationComponent,
          },
          { path: 'ref-type', canActivate: [roleBasedGuard([UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL])], component: RefTypeComponent },
          {
            path: 'company',
            canActivate: [roleBasedGuard([UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL])],
            children: [
              { path: '', component: CompanyComponent },
              { path: 'add', component: AddCompanyComponent },
              { path: 'update/:id', component: UpdateCompanyComponent },
              { path: 'inspect/:id', component: InspectCompanyComponent },
            ],
          },
          {
            path: 'requests-list',
            canActivate: [roleBasedGuard([UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL])],
            children: [
              { path: '', component: CompanyRequestComponent },
              {
                path: 'treat/:id',
                component: TreatCompanyRequestComponent,
              },
              {
                path: 'blacklist',
                component: CompanySubmissionsBlacklistComponent,
              },
            ],
          },
          {
            path: 'committee',
            canActivate: [roleBasedGuard([UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL])],
            children: [
              {
                path: '',
                component: CommitteeComponent,
              },
              {
                path: 'add',
                component: AddCommitteeComponent,
              },
              {
                path: 'update/:id',
                component: EditCommitteeComponent,
              },
              {
                path: 'history',
                component: CommitteeHistoryComponent,
              },
              {
                path: 'conselliers-history',
                component: ConselliersHistoryComponent,
              },
            ],
          },
          {
            path: 'user',
            canActivate: [roleBasedGuard([UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL, UserRole.ADMIN_AC])],
            children: [
              { path: '', component: UserComponent },
              { path: 'add', component: AddUserComponent },
              { path: 'update/:id', component: UpdateUserComponent },
            ],
          },
          {
            path: 'document-dynamics',
            canActivate: [roleBasedGuard([UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL])],
            component: DocumentDynamicsComponent,
          },
          {
            path: 'manage-document-dynamics',
            canActivate: [roleBasedGuard([UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL])],
            component: ManageDocumentDynamicsComponent,
          },
          {
            path: 'manage-document-dynamics/:id',
            canActivate: [roleBasedGuard([UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL])],
            component: ManageDocumentDynamicsComponent,
          },
          {
            path: 'general-parameters',
            canActivate: [roleBasedGuard([UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL])],
            component: DacGeneralParamsComponent,
          },
          {
            path: 'general-parameters/new',
            canActivate: [roleBasedGuard([UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL])],
            component: NewDacGeneralParamsComponent,
          },
          {
            path: 'general-parameters-edit/:id',
            canActivate: [roleBasedGuard([UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL])],
            component: EditDacGeneralParamsComponent,
          },
          {
            path: 'dynamic-forms',
            canActivate: [roleBasedGuard([UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL])],
            component: DynamicFormsComponent,
          },
          {
            path: 'dynamic-forms/new',
            canActivate: [roleBasedGuard([UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL])],
            component: NewDynamicFormComponent,
          },
          {
            path: 'dynamic-forms-inspect/:id',
            canActivate: [roleBasedGuard([UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL])],
            component: InspectDynamicFormComponent,
          },
          {
            path: 'dynamic-forms-edit/:id',
            canActivate: [roleBasedGuard([UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL])],
            component: EditDynamicFormComponent,
          },
          {
            path: 'email-trace',
            canActivate: [roleBasedGuard([UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL])],
            component: EmailTraceComponent,
          },
          {
            path: 'delais-reglementaires',
            canActivate: [roleBasedGuard([UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL])],
            component: DelaisReglementairesComponent,
          },
          {
            path: 'activities',
            canActivate: [roleBasedGuard([UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL])],
            component: ActivityComponent,
          },
          {
            path: 'doc-submission',
            canActivate: [roleBasedGuard([UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL])],
            component: DocSubmissionComponent,
          },
          {
            path: 'approval-types',
            canActivate: [roleBasedGuard([UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL])],
            component: ApprovalTypeComponent,
          },
          {
            path: 'funding-sources',
            canActivate: [roleBasedGuard([UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL])],
            component: FundingSourcesComponent,
          },
          {
            path: 'dyna-docs-models',
            canActivate: [roleBasedGuard([UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL])],
            component: DynaDocsModelsComponent,
          },
          {
            path: 'seuils',
            canActivate: [roleBasedGuard([UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL])],
            component: SeuilsGlobalComponent,
          },
          {
            path: 'submitted-bids',
            canActivate: [roleBasedGuard([UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL, UserRole.ADMIN_AC])],
            loadComponent: () => import('./pages/settings/submitted-bids/submitted-bids.component').then(m => m.SubmittedBidsComponent),
          },
          {
            path: 'downloaded-dacs',
            canActivate: [roleBasedGuard([UserRole.SUPER_ADMIN, UserRole.ADMIN_CENTRAL, UserRole.ADMIN_AC])],
            loadComponent: () => import('./pages/settings/downloaded-dacs/downloaded-dacs.component').then(m => m.DownloadedDacsComponent),
          },

        ],
      },
    ],
  },
];
